/**
 * 品牌 表单配置处理
 * @author zjs
 * @time 2017-12-12
 */
export default {
    data () {
        return {
            formConfig: [{
                name: "品牌名称",
                type: "ElInput",
                field: "brand_name"
            }, {
                name: "品牌编码",
                type: "ElInput",
                field: "jindie_id"
            }, {
                name: "制造商",
                type: "ElInput",
                field: "zhizaoshang_name"
            }, {
                name: "状态",
                type: "LySelect",
                json: {
                    all: false,
                    data: [{
                        value: '1',
                        label: '启用'
                    }, {
                        value: '0',
                        label: '停用'
                    }]
                },
                field: "status",
                default: '1'
            }, {
                field: 'weidu_id',
                name: '核算纬度',
                type: 'LySelect',
                json: {
                    defOne: true,
                    all: false,
                    api: "api/accountingDimension"
                }
            }, {
                name: "手机端是否显示",
                type: "LySelect",
                json: {
                    all: false,
                    data: [{
                        value: '0',
                        label: '否'
                    }, {
                        value: '1',
                        label: '是'
                    }]
                },
                field: "is_client_show",
                default: '0'
            }]
        }
    }
}